// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1CZKq","empty":"ModalGraph_empty__4-s-t"};